var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "ui-dropdown" },
      on: {
        "after-enter": function($event) {
          _vm.allowClose = true
        },
        "before-leave": function($event) {
          _vm.allowClose = false
        }
      }
    },
    [
      _vm.visible
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.close,
                  expression: "close"
                }
              ],
              class: _vm.classList
            },
            [
              _vm.$slots.header ? _c("div", [_vm._t("header")], 2) : _vm._e(),
              _c("div", { ref: "content", class: ["ui-dropdown-content"] }, [
                _c(
                  "div",
                  {
                    ref: "scrollview",
                    class: [
                      "ui-dropdown-scrollview",
                      { "ui-dropdown-scrollable": _vm.contentScrollable }
                    ]
                  },
                  [_vm._t("default", null, { close: _vm.close })],
                  2
                ),
                _vm.contentScrollable && _vm.overlayHeight
                  ? _c("div", {
                      staticClass: "ui-dropdown-overlay",
                      style: {
                        transform: "translateY(" + _vm.overlayOffset + "px)",
                        height: _vm.overlayHeight + "px"
                      }
                    })
                  : _vm._e()
              ]),
              _vm.$slots.footer
                ? _c(
                    "div",
                    { staticClass: "ui-dropdown-footer" },
                    [_vm._t("footer")],
                    2
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }